import { api } from '../../../lib/api'

export const READ_MESSAGE_REQUEST = 'READ_MESSAGE_REQUEST'
export const READ_MESSAGE_SUCCESS = 'READ_MESSAGE_SUCCESS'
export const READ_MESSAGE_FAILED = 'READ_MESSAGE_FAILED'

export const readMessages = function (messageIds) {
  return function (dispatch) {
    dispatch({
      type: READ_MESSAGE_REQUEST
    })
    api.readMessages(messageIds).then(readMessageResponse => {
      dispatch({
        type: READ_MESSAGE_SUCCESS,
        payload: readMessageResponse,
        messageIds
      })
    }).catch(error => {
      dispatch({
        type: READ_MESSAGE_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/message/read-message.js